module.exports = __webpack_public_path__ + "img/pickup-summary.fa8a0889.svg";